import * as React from 'react';
import useAuth from '../../features/hooks/useAuth';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';
import nameStringFn from '../../data/nameStringFn';
import { Span } from '../../Styles/CommonStyles';



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const FieldValue = styled.div`
  margin-bottom: 15px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

export default function SupportDetailsModal({supportdetailmodalopen,supportdetailModaldata, handleSupportDetailModalClose}) {

  const Auth = useAuth();

  const fields = supportdetailModaldata? [
    { label: 'Name', value: `${nameStringFn(supportdetailModaldata)}`},
    { label: 'Email', value: supportdetailModaldata?.email },
    { label: 'Mobile', value: supportdetailModaldata?.mobileNo },
    { label: 'Roles', value: supportdetailModaldata.roles.map(x => `${x}, `)},
    { label: 'Store', value: supportdetailModaldata?.store},
    { label: 'Asset Categories', value: supportdetailModaldata?.assetCategories.map(x => `${x}, `)},
    { label: 'Complaint Categories', value: supportdetailModaldata?.complaintCategories.map(x => `${x}, `)},
    { label: 'Assigned Complaints', value:supportdetailModaldata?.assignedComplaint.length? `${supportdetailModaldata?.assignedComplaint.length} Nos (${supportdetailModaldata?.assignedComplaint.map(x => `${x}, `)})`:null},
    { label: 'Available', value: supportdetailModaldata?.available? "True":"False"},
    { label: 'Disabled', value: supportdetailModaldata?.disabled? "True":"False"},   
  ]:[];
  return (
    <React.Fragment>
      <Dialog  onClose={handleSupportDetailModalClose} aria-labelledby="customized-dialog-title" open={supportdetailmodalopen} fullWidth maxWidth="md">
        <DialogTitle>
          <Span>Support User Details</Span>
        </DialogTitle>
          <DialogContent dividers>
            <ModalContent>
              <Table>
              <tbody>
              {fields.map((item, index)=>
                <tr id='email' key ={index}>
                    <TableCell>
                      <TableHeader>
                        {item?.label}
                      </TableHeader>
                    </TableCell>
                    
                    <TableCell>
                      { item?.value}
                    </TableCell>
                  </tr>
                )
              }              
            </tbody>
                  </Table>
            </ModalContent>
          </DialogContent>

            <DialogActions >
              <Button onClick={handleSupportDetailModalClose}>Close</Button>
            </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
